import styled from 'styled-components';
import { PaymentMethodForm } from '@perch-labs/shrike';

export const StyledPaymentMethodForm = styled(PaymentMethodForm)`
  padding-top: 40px;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
`;
